import type { SurveyAnswersState as MergedSurveyAnswers } from "@utils/redux/slices/surveyAnswers";
import { MED_SKU } from "src/utils/medEligibility";

function isProductEligible(eligibleProducts: MED_SKU[], sku: MED_SKU): boolean {
  return eligibleProducts.includes(sku);
}

export function getRecommendedMedSkuFromMedicationPreferenceAnswers(
  eligibleProducts: MED_SKU[],
  answers: Pick<
    MergedSurveyAnswers,
    "medicationPreference" | "medicationPreferenceRecommendedMedTier"
  >
): MED_SKU | undefined {
  const { medicationPreference, medicationPreferenceRecommendedMedTier } =
    answers;

  if (
    medicationPreference === "RECOMMENDATION" &&
    medicationPreferenceRecommendedMedTier &&
    isProductEligible(eligibleProducts, medicationPreferenceRecommendedMedTier)
  ) {
    return medicationPreferenceRecommendedMedTier;
  }

  if (
    medicationPreference &&
    medicationPreference !== "RECOMMENDATION" &&
    isProductEligible(eligibleProducts, medicationPreference as MED_SKU)
  ) {
    return medicationPreference as MED_SKU;
  }

  return undefined;
}
